import React from 'react';
import Modal from 'react-modal';
// import Cookies from 'js-cookie';
// import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
import _ from 'lodash';
import '../css/SystemIntegratorEdit.css';
// import ErrorText from '../ErrorText';
// import cities from './cities';
import Loader from './Loader';
import SnackBar from './SnackBar';

//Distributor edit page  component
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
        // background: 'none !important'
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};


const customStylesSuccess = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '70%',
        overflow: 'auto',
        padding: '2%',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};



export default class VideoEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
            noOfParams: [],
            Title: this.props.siCurrentData.title,
            Video: this.props.siCurrentData.video,
            Description: this.props.siCurrentData.description,
            YoutubeVideo: this.props.siCurrentData.yt_video,
            uploadedFile: null,
            errorMessage: [],
            modalIsOpenSuccess: false,
            loader: false,
            disableSave: true,
            snackbarActive: false,
            snackbarMessage: ''

        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalSuccess = this.closeModalSuccess.bind(this);

    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }


    closeModalSuccess() {
        this.setState({
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpenSuccess: false
                }, () => {
                    this.props.closeAllModal()
                })
            }, 500);

        })
    }
    afterOpenModal() {
    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => {
                    this.props.closeAllModal()
                })
            }, 500);

        })
    }



    componentDidMount() {
        this.fecthAllSI();
    }

    fecthAllSI = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/video-library', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {

                this.setState({
                    siData: data

                })
                //    console.log(this.state.siData);  // Check Get distributors data
            })
            .catch((err) => {
                console.log(err)

            })
    }


    onEditFinal = () => {
        const tokenStored = `Token ${localStorage.getItem('token')}`;
        const headers = {
            "Authorization": tokenStored,
            'X-CSRFToken': localStorage.getItem('csrftoken'), // CSRF token if required
        };

        const { Title: title, Video: video, Description: description, YoutubeVideo: yt_video } = this.state;



        // Create FormData object
        const formData = new FormData();
        formData.append('title', title);
        formData.append('video', video); // Add the file
        formData.append('description', description);
        formData.append('yt_video', yt_video);

        fetch(`/cloud/video-library/${this.props.siCurrentData.id}/`, {
            method: "PUT",
            headers, // Don't include 'Content-Type' for FormData
            body: formData, // Use the FormData object
        })
            .then((response) => {
                if (response.status === 403) {
                    // Handle session timeout
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true });
                    window.location.href = '/session-timeout'
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                let rawData = data;
                data = data;
                const index = Object.keys(data)[0];
                console.log(`${index}: ${data[Object.keys(data)[0]]}`);
                const errorLog = `${index}: ${data[Object.keys(data)[0]]}`;

                if (rawData.message !== 'failure') {
                    // Success case
                    this.setState({
                        modalIsOpen: false,
                        loader: false,
                        modalIsOpenSuccess: true,
                    });
                } else {
                    // Failure case
                    this.setState({
                        loader: false,
                        snackbarActive: true,
                        snackbarMessage: errorLog,
                    });
                    //console.log('PUT request failed:', this.state.data);
                }
            })
            .catch((err) => {
                console.log(err); // Log the error
            });
    };


    handleChangeInputBox = (name, event) => {
        this.setState({
            [name]: event,
            disableSave: false,

        });
    };


    onEdit = () => {
        console.log('Editing ID:', this.props.siCurrentData.id);
        this.setState({
            showErrorMessage: true,
            loader: true,      // Start loader
            disableSave: true  // Disable save button
        }, () => this.onEditFinal()); // Directly call onEditFinal
    };


    handleFileUpload(event) {
        const file = event.target.files[0];
        if (file && file.type.startsWith('video/')) {
            this.setState({ Video: file, showErrorMessage: false, disableSave: false, uploadedFile: file });

        } else {
            this.setState({ Video: null, showErrorMessage: true });
            alert('Please upload a valid Video file.');
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.loader ? <Loader /> : null}
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>Edit Knowledge Bank</h3>
                    <div className="row">
                        <div className="col-6  mx-0 px-0" >
                            <InputBox
                                inputText={this.state.Title}
                                placeholder="Title"
                                inputBoxName="Title"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                textLength={50}
                                validate={true}
                            />
                        </div>

                        <div className="col-6">

                            <input
                                type="file"
                                // value={"hell"}
                                accept="video/*"
                                onChange={(event) => this.handleFileUpload(event)}
                                style={{ marginTop: '10px' }}
                                // error={ErrorText('notEmpty', this.state.KnowledgeTitle) !== 'No Error' && this.state.showErrorMessage ? true : false}
                                // errorText={ErrorText('notEmpty', this.state.KnowledgeTitle) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the Knowledge Bank Title' : ''}
                                placeholder="Video"
                                disabled={this.state.YoutubeVideo}
                            />
                            {/* {
                                this.state.PDF ? <span>{this.state.PDF.split("/").pop().split("_")[0]
                                }</span> : ""
                            } */}
                        </div>
                        <div className="col-6  mx-0 px-0" >

                            <InputBox
                                inputText={this.state.Description}
                                // error={ErrorText('email', this.state.SiEmail) !== 'No Error' && this.state.showErrorMessage ? true : false}
                                // errorText={ErrorText('email', this.state.SiEmail) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Distributor Email' : ''}
                                placeholder="Description"
                                inputBoxName="Description"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                textLength={255}
                                blockSpecialChar={false} // ✅ prevent special char input
                            />
                        </div>

                        <div className="col-6" >

                            {/* <InputBox
                                inputText={this.state.YoutubeVideo}
                                // error={ErrorText('email', this.state.SiEmail) !== 'No Error' && this.state.showErrorMessage ? true : false}
                                // errorText={ErrorText('email', this.state.SiEmail) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Distributor Email' : ''}
                                placeholder="YouTube Video Link"
                                inputBoxName="YoutubeVideo"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                textLength={255} /> */}
                            <InputBox
                                inputText={this.state.YoutubeVideo}
                                error={
                                    this.state.YoutubeVideo &&
                                    !(
                                        this.state.YoutubeVideo.startsWith('https://') &&
                                        /^(https:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(this.state.YoutubeVideo)
                                    )
                                }
                                errorText={
                                    this.state.YoutubeVideo &&
                                        !(
                                            this.state.YoutubeVideo.startsWith('https://') &&
                                            /^(https:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(this.state.YoutubeVideo)
                                        )
                                        ? 'Please enter a valid YouTube link starting with https'
                                        : ''
                                }
                                placeholder="YouTube Video Link"
                                inputBoxName="YoutubeVideo"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                textLength={255}
                                disabled={this.state.uploadedFile}
                                blockSpecialChar={false}
                            />

                        </div>

                    </div>
                    <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey" onClick={this.closeModal} style={{ marginRight: '15px' }} >Cancel</div>
                        <div className="btn btn-new-green" onClick={() => {
                            if (!this.state.disableSave) {
                                this.onEdit()
                            }
                        }
                        }
                            style={{
                                cursor: this.state.disableSave ? 'not-allowed' : '',
                            }}
                        >Save Changes</div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.modalIsOpenSuccess}
                    style={customStylesSuccess}
                    className={this.state.modalStateAftereOpenSuccess}
                    contentLabel="Example Modal">
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                            <i className="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <div className="display-4 text-center">
                        <h3 className="modal-heading thanks-message">Video edited successfully.</h3>
                        <i class="fas fa-check-circle update"></i>
                        <br />
                        <div className="btn btn-new-grey"
                            onClick={this.closeModalSuccess}>
                            Close
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
